import { connect } from 'react-redux';
import { setViewState, setCookiePopup } from '../../actions';
import MapView from './MapView';

export default connect(
	({ viewStateReducer, cookiePopupReducer }) => ({ viewState: viewStateReducer, popupState: cookiePopupReducer }),
	{ setViewState, setCookiePopup }
)(MapView);